import { RATIO_OF_MOLLAR_MASSES as cToCo2 } from './constants'

type SoderbergPayload = {
  pasteConsumption: number // t/t Al
  cyclohexaneSolubleMatterEmissions: number // kg/t Al
  binderContentInPaste: number // wt %
  sulphurContentInPitch: number // wt %
  ashContentInPitch: number // wt %
  hydrogenContentInPitch: number // wt %
  sulphurContentInCalcinedCoke: number // wt %
  ashContentInCalcinedCoke: number // wt %
  carbonInSkimmedDustFromSoderbergCell: number // t C/t Al
  aluminiumQuantity: number // t Al/t Al
}

export default function calculateProcessEmissionsFromSoderbergCell(
  payload: SoderbergPayload
): number {
  const {
    pasteConsumption: anodeQuantityPerTonneAluminium,
    cyclohexaneSolubleMatterEmissions: cycloQuantityKgPerTonneAluminium,
    binderContentInPaste: binderQuantity,
    sulphurContentInPitch: sulphurPitch,
    ashContentInPitch: ashPitch,
    hydrogenContentInPitch: hydPitch,
    sulphurContentInCalcinedCoke: sulphurCoke,
    ashContentInCalcinedCoke: ashCoke,
    carbonInSkimmedDustFromSoderbergCell: carbonDust,
    aluminiumQuantity
  } = payload

  const totalAnodes = anodeQuantityPerTonneAluminium * aluminiumQuantity
  const totalCyclohexaneTonnes = cycloQuantityKgPerTonneAluminium * aluminiumQuantity
  const emissions =
    (totalAnodes -
      totalCyclohexaneTonnes / 1000 -
      (binderQuantity / 100) *
        anodeQuantityPerTonneAluminium *
        aluminiumQuantity *
        ((sulphurPitch + ashPitch + hydPitch) / 100) -
      ((100 - binderQuantity) / 100) *
        anodeQuantityPerTonneAluminium *
        aluminiumQuantity *
        ((sulphurCoke + ashCoke) / 100) -
      aluminiumQuantity * carbonDust) *
    cToCo2

  return emissions
}
